function updateStockFlag(variant) {
  // This accepts any object that has a field called `id` that contains a valid variant id.

  // This is only true after we've pulled the stock data.
  // When the data is pulled, this method gets called automatically.
  if(!hasStockData) {
    return;
  }

  // This converts the variant to a format we can actually use here.
  variant = fulfillments[variant.id];

  if (variant.fulfillment_service == "manual") {
    handleManualFulfillment(variant);
  } else {
    handleDropShippedItem(variant);
  }

  // Handles items with manual fulfillment
  function handleManualFulfillment(variant) {
    var etaTags = getEtaTags(variant);
    if (variant.inventory_quantity > 0) {
      handleAvailableManualItem(variant);
    } else if (variant.inventory_policy == "continue") {
      handleBackorderedManualItem(variant);
    } else if (etaTags.length > 0){
      // Unavailable - Arrives $date
      var eta_message = "Arrives $date".replace("$date", etaTags[0].split('_')[1]);
      setStockFlag("Unavailable", eta_message, 'unavailable', true)
    } else {
      // Item is unavailable
      setStockFlag("Unavailable", "Get Notified Below", 'unavailable', true);
    }
  }

  // Handles manual items currently in stock
  function handleAvailableManualItem(variant) {
    var leadTimeTags = getLeadTimeTags(variant);
    if (leadTimeTags.length > 0){
      // In stock - ships in X - X business days
      var leadTimeRange = leadTimeTags[0].split('_');
      var lead_time_message = "Ships in $first to $last business days"
        .replace("$first", leadTimeRange[1])
        .replace("$last", leadTimeRange[2]);
      setStockFlag("In Stock", lead_time_message, 'available')
    } else {
      // In stock - Ships Now
      setStockFlag("In Stock", "Ships now", 'available')
    }
  }

  // Handles manual items currently on backorder
  function handleBackorderedManualItem(variant) {
    var etaTags = getEtaTags(variant);
    var basic = document.getElementById('add');
    //basic.value = 'PRE-ORDER NOW';
    document.getElementById('pre-order-save-img').style.display = "block";
    $('.global_preorder').html('<input type="hidden" name="properties[_preorder]" value="Preorder Yes" />');
    
        
    if (etaTags.length > 0){
      // Backordered - Arrives $date
      var eta_message = "Arrives $date".replace("$date", etaTags[0].split('_')[1]);
      setStockFlag("Backordered", eta_message, 'backordered', true)
    } else {
      // Backordered - Get Notified
      setStockFlag("Backordered", "Get Notified Below", 'backordered', true)         
    }
  }

  // Handles items with automatic fulfillment
  function handleDropShippedItem(variant) {
    var etaTags = getEtaTags(variant);
    var leadTimeTags = getLeadTimeTags(variant);

    if (variant.inventory_policy != "continue" && etaTags.length > 0) {
      // Unavailable - Arrives $date
      var eta_message = "Arrives $date".replace("$date", etaTags[0].split('_')[1]);
      setStockFlag("Unavailable", eta_message, 'unavailable', true)
    } else if (variant.inventory_policy != "continue") {
      // Unavailable - get notified
      setStockFlag("Unavailable", "Get Notified Below", 'unavailable', true)
    } else if (etaTags.length > 0 ) {
      // Backordered - Arrives $date
      var eta_message = "Arrives $date".replace("$date", etaTags[0].split('_')[1]);
      setStockFlag("Backordered", eta_message, 'backordered', true)
    } else if (leadTimeTags.length > 0) {
      // Available - Ships in X - X business days
      var leadTimeRange = leadTimeTags[0].split('_');
      var lead_time_message = "Ships in $first to $last business days"
        .replace("$first", leadTimeRange[1])
        .replace("$last", leadTimeRange[2]);
      setStockFlag("Available", lead_time_message, 'available')
    } else {
      // Available - Ships Now
      setStockFlag("Available", "Ships now", 'available')
    }
  }

  function setStockFlag(header, subheader, style, showEmailButton) {
    var flag_contents = "\
      <span class=\"stock-flag-header " + style + "\">" + header + " " + " <span class=\"stock-subtext " + style + "\">" + "– " + subheader + "</span></span>";
    $('.stock-flag').html(flag_contents);

    if (showEmailButton) {
      $('#sold-out').show();
    } else {
      $('#sold-out').hide();
    }
  }

  function getEtaTags(variant) {
    return getTags(variant, 'eta_');
  }

  function getLeadTimeTags(variant) {
    return getTags(variant, 'lead_');
  }
  
  function getTags(variant, string) {
    return variant.tags.filter(function(element) {
      return element.toLowerCase().startsWith(string.toLowerCase());
    });
  }
}

$.getJSON('/products/' + current_handle + '.json', function(json) {
  json.product.variants.forEach(function(el) {
    fulfillments[el.id] = {};
    fulfillments[el.id].id = el.id;
    fulfillments[el.id].fulfillment_service = el.fulfillment_service;
    fulfillments[el.id].inventory_quantity = el.inventory_quantity;
    fulfillments[el.id].inventory_policy = el.inventory_policy;
    fulfillments[el.id].tags = json.product.tags.split(", ");
  });

  hasStockData = true;
  updateStockFlag(fulfillments[current_variant]);
  toggleInventoryCount(current_variant);
  return hasStockData;
});

function toggleInventoryCount(variant_id) {
  if (fulfillments[variant_id].inventory_policy == "deny" && fulfillments[variant_id].inventory_quantity > 0) {
    updateInventoryCount(variant_id);
  } else {
    $('.inventory-quantity').hide();
  }
}

function updateInventoryCount(variant_id) {
  if (fulfillments[variant_id].inventory_quantity <= 10) {
    $('.inventory-quantity').show();
    $('.inventory-quantity').html('<p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Order soon, only <span class="variant-quantity">' + fulfillments[variant_id].inventory_quantity + '</span> left!</p>');
  } else {
    $('.inventory-quantity').show();
    $('.inventory-quantity').html('<p><i class="fa fa-exclamation-triangle" aria-hidden="true"></i> Order soon, only <span class="variant-quantity">' + fulfillments[variant_id].inventory_quantity + '</span> left!</p>');
  }
}